import React, { useState, useEffect } from 'react';
import { getCVEgetCveOrKve } from '../services';
import CveModal from './CveModal';
import Loading from './DocList/Loading';

const CveList = ({ profile, onlyKve, cveFields }) => {
  const [docs, setDocs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    if (profile) {
      getCVEgetCveOrKve(profile, onlyKve).then((res) => {
        setIsLoading(false);
        setDocs(res.documents);
      });
    }
  }, [profile, onlyKve]);

  return (
    <div>
      <h5 data-testid='latest-critical-vulnerabilities-title'>
        Latest Critical Vulnerability Reports
      </h5>
      {isLoading ? <Loading text={`loading ${onlyKve ? 'KEVs' : 'CVEs'}`} /> : null}
      {!isLoading && docs.length ? (
        <div id='cve-list' className='cve-list'>
          {Object.entries(docs).map(([key, value]) => (
            <div className='cve-meta' key={value.id}>
              <span className='cve-id'>{value.id}</span>
              <h4>
                <a href={value.url} target='_blank' rel='noreferrer'>
                  {value.title}
                </a>
              </h4>
              <span className='cve-field-group cve-publish-date'>
                <span className='cve-label'>Published on:</span>
                <span className='cve-value'>{value.publishDate}</span>
              </span>
              <CveModal
                cve={value}
                onlyKve={onlyKve}
                cveFields={cveFields}
                profile={profile}
              />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};
export default CveList;
